import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";

const INVITE_KEY = "pantry_pending_invite";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser, refresh } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    const sid = m ? decodeURIComponent(m[1]) : null;
    if (!sid) {
      navigate("/", { replace: true });
      return;
    }
    (async () => {
      try {
        const res = await api.post("/auth/session", { session_id: sid });
        let user = res?.data?.user;
        // Clear hash
        window.history.replaceState(null, "", window.location.pathname);
        // Auto-join if we have a pending invite and user has no household yet
        let pendingInvite = null;
        try { pendingInvite = localStorage.getItem(INVITE_KEY); } catch (_e) { /* noop */ }
        if (user && !user.household_id && pendingInvite) {
          try {
            await api.post("/households/join", { invite_code: pendingInvite.toUpperCase() });
            try { localStorage.removeItem(INVITE_KEY); } catch (_e) { /* noop */ }
            // Refresh to pick up the new household_id
            const me = await api.get("/auth/me");
            user = me.data;
          } catch (_e) {
            // Bad code: fall back to onboarding with hint in localStorage
            // keep invite so Onboarding can prefill the Join tab
          }
        }
        if (user) {
          setUser(user);
          if (!user.household_id) {
            navigate("/onboarding", { replace: true });
          } else {
            // Clear any stale invite once the user is in a household
            try { localStorage.removeItem(INVITE_KEY); } catch (_e) { /* noop */ }
            navigate("/dashboard", { replace: true });
          }
        } else {
          await refresh();
          navigate("/dashboard", { replace: true });
        }
      } catch (_e) {
        navigate("/", { replace: true });
      }
    })();
  }, [navigate, setUser, refresh]);

  return (
    <div className="min-h-screen flex items-center justify-center" data-testid="auth-callback">
      <div className="animate-fade-in text-zinc-500 text-sm">Signing you in…</div>
    </div>
  );
}
